import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import { I18nProvider } from "@/i18n/I18nProvider";
import { useLenis } from "@/hooks/useLenis";
import { useScrollToTop } from "@/hooks/useScrollToTop";

import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";

import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function DetectDefaultLang() {
  // Redirect / to /ar (default Spanish for Argentina)
  return <Navigate to="/ar" replace />;
}

function Shell() {
  useLenis();
  useScrollToTop();
  const { pathname } = useLocation();
  const isThankYou = pathname === "/thank_you";

  return (
    <>
      <a href="#main" className="skip-link">Ir al contenido principal</a>
      {!isThankYou && <Header />}
      <Routes>
        <Route path="/" element={<DetectDefaultLang />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/ar" element={<Home />} />
        <Route path="/en" element={<Home />} />
        <Route path="/ar/privacy" element={<LegalPage pageKey="privacy" testId="privacy-page" />} />
        <Route path="/en/privacy" element={<LegalPage pageKey="privacy" testId="privacy-page" />} />
        <Route path="/ar/cookies" element={<LegalPage pageKey="cookies" testId="cookies-page" />} />
        <Route path="/en/cookies" element={<LegalPage pageKey="cookies" testId="cookies-page" />} />
        <Route path="/ar/terms" element={<LegalPage pageKey="terms" testId="terms-page" />} />
        <Route path="/en/terms" element={<LegalPage pageKey="terms" testId="terms-page" />} />
        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
      {!isThankYou && <Footer />}
      {!isThankYou && <CookieBanner />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <Shell />
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
